import React, { useState } from "react";
import "./Carousel.css";
import homequality from "../../assets/home_quality_mobile.png";
import hand_phone from "../../assets/images/home/phone_hand.png";
import { Link } from "react-router-dom";
import LoginDialog from "../Addons/LoginModalBox";
const HomeQuality = () => {
  const [openDialog, setOpenDialog] = useState(false);

  return (
    <>
      <div className="home-quality w-full md:flex hidden justify-center items-center">
        {/* Container added here */}
        <div
          className="sm:max-w-full md:max-w-[80%] xl:max-w-[80rem] 3xl:max-w-[90rem] mx-auto w-full xl:py-20 py-8  px-5 flex flex-col"
          data-aos="fade-up"
        >
          <p
            className="text-[40px] md:text-[50px]  xl:text-[60px] font-extralight font-lexend text-[#3b6840]"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            SLEEP LIGHT
          </p>

          <p
            className=" text-[15px] md:text-[19px] text-[#3f3f3f] font-light font-lexend md:py-5"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            Every material we use, every technology we adapt <br /> and every
            process we follow is with one goal <br /> in mind — giving you the
            best sleep experience ever.
          </p>

          <div data-aos="fade-up" data-aos-delay="300">
            <Link
              to="/certifications"
              className="relative px-6 py-4 xl:text-[22px] sm:text-xl mt-5 font-normal font-lexend shadow tracking-wider uppercase  bg-transparent isolation-auto z-10 border-2 border-[#3b6840] before:absolute before:w-full before:transition-all before:duration-700 before:hover:w-full hover:text-white before:-left-full before:hover:left-0 before:rounded-full before:bg-[#3b6840] before:-z-10 before:aspect-square before:hover:scale-150 overflow-hidden before:hover:duration-700 inline-flex items-center justify-center text-[#3b6840]  gap-x-2 disabled:opacity-50 disabled:pointer-events-none hover:font-normal hover:text-[22px]"
            >
              CERTIFICATIONS & QUALITY
            </Link>
          </div>
        </div>
      </div>

      <div className=" w-full md:hidden flex flex-col justify-center items-center px-3 pb-2 bg-[#fdf9ed]">
        {/* Container added here */}
        <div
          className="  mx-auto w-full xl:py-20 sm:py-6 py-8 bg-[#d9eada] px-5 flex flex-col"
          data-aos="fade-up"
        >
          <p
            className="text-[40px] sm:text-[25px] font-light font-lexend text-[#3b6840]"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            SLEEP LIGHT
          </p>

          <p
            className=" text-[15px] sm:text-[12px]  text-[#3f3f3f] font-normal font-lexend sm:py-4 py-5"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            Every material we use, every technology we adapt and every process
            we follow is with one goal in mind — giving you the best sleep
            experience ever.
          </p>

          <div data-aos="fade-up" data-aos-delay="300">
            <Link
              to="/certifications"
              className="relative px-6 sm:px-3 sm:py-1.5 py-3 w-full xl:text-[22px] sm:text-[14px] mt-1 text-xl font-normal font-lexend shadow tracking-wider uppercase  bg-transparent isolation-auto z-10 border-2 border-[#3b6840] before:absolute before:w-full before:transition-all before:duration-700 before:hover:w-full hover:text-white before:-left-full before:hover:left-0 before:rounded-full before:bg-[#3b6840] before:-z-10 before:aspect-square before:hover:scale-150 overflow-hidden before:hover:duration-700 inline-flex items-center justify-center text-[#3b6840]  gap-x-2 disabled:opacity-50 disabled:pointer-events-none hover:font-normal hover:text-[14px]"
            >
              CERTIFICATIONS & QUALITY
            </Link>
          </div>
        </div>
        <img src={homequality} alt="images" className="w-full " />
        <div className="mx-auto w-full  py-4  bg-[#d9eada] px-5 flex flex-col">
          <p
            className=" sm:text-[25px] text-[30px] font-light font-lexend uppercase text-[#3b6840]"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            your perfect <br /> mondew, <br /> in 60 seconds
          </p>
          <p
            className="xs:text-[12px] text-[12px] font-medium mt-2 pe-3 font-lexend text-[#3f3f3f] "
            data-aos="fade-up"
            data-aos-delay="200"
          >
            Mixed sleeper? Family bed? Posture concerns? Set aside the
            guesswork. Help us recommend the mattress that works best for you.
          </p>
          <button className="relative px-6 sm:px-3 sm:py-1.5 py-3 sm:w-[175px]  sm:text-[14px] mt-5 mb-3 text-xl font-normal font-lexend shadow tracking-wider uppercase  bg-transparent isolation-auto z-10 border-2 border-[#3b6840] before:absolute before:w-full before:transition-all before:duration-700 before:hover:w-full hover:text-white before:-left-full before:hover:left-0 before:rounded-full before:bg-[#3b6840] before:-z-10 before:aspect-square before:hover:scale-150 overflow-hidden before:hover:duration-700 inline-flex items-center justify-center text-[#3b6840]  gap-x-2 disabled:opacity-50 disabled:pointer-events-none hover:font-normal hover:text-[14px]">
            TAKE THE QUIZ
          </button>
        </div>
        <div className="mx-auto w-full  py-11 my-3 bg-[#d9eada] px-5 flex justify-between items-center">
          <p
            className="xs:text-[12px] text-[12px] font-medium   font-lexend text-[#3f3f3f] "
            data-aos="fade-up"
            data-aos-delay="200"
          >
            Night-time routines <br />
            for the best sleep <br />
          </p>
          <button className="relative px-4 w-[120px] sm:px-1 sm:py-1.5 py-2   sm:text-[14px] text-xl font-normal font-lexend shadow tracking-wider uppercase  bg-transparent isolation-auto z-10 border-2 border-[#3b6840] before:absolute before:w-full before:transition-all before:duration-700 before:hover:w-full hover:text-white before:-left-full before:hover:left-0 before:rounded-full before:bg-[#3b6840] before:-z-10 before:aspect-square before:hover:scale-150 overflow-hidden before:hover:duration-700 inline-flex items-center justify-center text-[#3b6840]  gap-x-2 disabled:opacity-50 disabled:pointer-events-none hover:font-normal hover:text-[14px]">
            BLOG
          </button>
        </div>
        <div className="mx-auto relative overflow-hidden w-full bg-[#d9eada] px-5 mb-1 flex justify-between items-center">
          <div>
            <p
              className="xs:text-[12px] text-[12px] font-medium py-10  font-lexend text-[#3f3f3f] "
              data-aos="fade-up"
              data-aos-delay="200"
            >
              Want to transform <br /> your sleep experience? <br /> Sign up for
              "Rethink Sleep", <br /> our monthly newsletter.
            </p>
            <button
              onClick={() => {
                setOpenDialog(true);
              }}
              className="relative px-4 w-[120px] sm:px-1 sm:py-1.5 py-2  mb-10 sm:text-[14px] text-xl font-normal font-lexend shadow tracking-wider uppercase  bg-transparent isolation-auto z-10 border-2 border-[#3b6840] before:absolute before:w-full before:transition-all before:duration-700 before:hover:w-full hover:text-white before:-left-full before:hover:left-0 before:rounded-full before:bg-[#3b6840] before:-z-10 before:aspect-square before:hover:scale-150 overflow-hidden before:hover:duration-700 inline-flex items-center justify-center text-[#3b6840]  gap-x-2 disabled:opacity-50 disabled:pointer-events-none hover:font-normal hover:text-[14px]"
            >
              SIGN-UP
            </button>
          </div>
          <div className="absolute -right-2 bottom-0 ">
            <img src={hand_phone} alt="" />
          </div>
        </div>
      </div>
      <LoginDialog open={openDialog} handleClose={() => setOpenDialog(false)} />
    </>
  );
};

export default HomeQuality;
